/**
 * League Manager - Shared utilities and constants
 */
import axios from "axios";

export const API = process.env.REACT_APP_BACKEND_URL + "/api";

export const getAuthHeader = () => {
  const token = localStorage.getItem("auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Color presets for quick selection
export const COLOR_PRESETS = [
  "#f97316", "#ef4444", "#22c55e", "#3b82f6", "#8b5cf6",
  "#ec4899", "#14b8a6", "#f59e0b", "#6366f1", "#84cc16"
];

// League API helpers
export const leagueAPI = {
  getLeagues: () => axios.get(`${API}/leagues`, { headers: getAuthHeader() }),
  getLeague: (id) => axios.get(`${API}/leagues/${id}`, { headers: getAuthHeader() }),
  createLeague: (data) => axios.post(`${API}/leagues`, data, { headers: getAuthHeader() }),
  updateLeague: (id, data) => axios.put(`${API}/leagues/${id}`, data, { headers: getAuthHeader() }),
  deleteLeague: (id) => axios.delete(`${API}/leagues/${id}`, { headers: getAuthHeader() }),
  
  // Conferences
  createConference: (leagueId, data) => axios.post(`${API}/leagues/${leagueId}/conferences`, data, { headers: getAuthHeader() }),
  updateConference: (leagueId, confId, data) => axios.put(`${API}/leagues/${leagueId}/conferences/${confId}`, data, { headers: getAuthHeader() }),
  deleteConference: (leagueId, confId) => axios.delete(`${API}/leagues/${leagueId}/conferences/${confId}`, { headers: getAuthHeader() }),
  
  // Divisions
  createDivision: (leagueId, data) => axios.post(`${API}/leagues/${leagueId}/divisions`, data, { headers: getAuthHeader() }),
  updateDivision: (leagueId, divId, data) => axios.put(`${API}/leagues/${leagueId}/divisions/${divId}`, data, { headers: getAuthHeader() }),
  deleteDivision: (leagueId, divId) => axios.delete(`${API}/leagues/${leagueId}/divisions/${divId}`, { headers: getAuthHeader() }),
  
  // Teams
  createTeam: (leagueId, data) => axios.post(`${API}/leagues/${leagueId}/teams`, data, { headers: getAuthHeader() }),
  updateTeam: (leagueId, teamId, data) => axios.put(`${API}/leagues/${leagueId}/teams/${teamId}`, data, { headers: getAuthHeader() }),
  deleteTeam: (leagueId, teamId) => axios.delete(`${API}/leagues/${leagueId}/teams/${teamId}`, { headers: getAuthHeader() }),
  
  // Playoffs
  createPlayoff: (leagueId, data) => axios.post(`${API}/leagues/${leagueId}/playoffs`, data, { headers: getAuthHeader() }),
  updatePlayoff: (leagueId, playoffId, data) => axios.put(`${API}/leagues/${leagueId}/playoffs/${playoffId}`, data, { headers: getAuthHeader() }),
  deletePlayoff: (leagueId, playoffId) => axios.delete(`${API}/leagues/${leagueId}/playoffs/${playoffId}`, { headers: getAuthHeader() }),
  updateMatchups: (leagueId, playoffId, matchups) => axios.put(`${API}/leagues/${leagueId}/playoffs/${playoffId}/matchups`, { matchups }, { headers: getAuthHeader() }),
  autoSeed: (leagueId, playoffId) => axios.post(`${API}/leagues/${leagueId}/playoffs/${playoffId}/auto-seed`, {}, { headers: getAuthHeader() }),
  
  // Games
  createGame: (leagueId, data) => axios.post(`${API}/leagues/${leagueId}/games`, data, { headers: getAuthHeader() }),
  updateGame: (leagueId, gameId, data) => axios.put(`${API}/leagues/${leagueId}/games/${gameId}`, data, { headers: getAuthHeader() }),
  deleteGame: (leagueId, gameId) => axios.delete(`${API}/leagues/${leagueId}/games/${gameId}`, { headers: getAuthHeader() }),
  updateGameResult: (leagueId, gameId, data) => axios.put(`${API}/leagues/${leagueId}/games/${gameId}/result`, data, { headers: getAuthHeader() }),
  
  // Standings
  updateStandings: (leagueId, standings) => axios.put(`${API}/leagues/${leagueId}/standings`, standings, { headers: getAuthHeader() }),
};

export default leagueAPI;
